<template>
    <div>
        <label v-if="hasLabel" :for="id" class="block text-sm font-medium text-gray-700">{{ label }} <span v-show="$attrs.required || false" class="font-bold text-teal">*</span></label>
        <div class="relative mt-1">
            <input ref="addressField" type="text" :id="id" v-bind="$attrs" @input="handleInput" :value="modelValue" class="block w-full border-gray-200 rounded-md focus:ring-teal focus:border-teal sm:text-sm">
        </div>
        <p v-if="desc" class="mt-2 text-sm text-gray-400">{{ desc }}</p>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import { Loader } from '@googlemaps/js-api-loader'

export default defineComponent({
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default(){
                return 'address-field-' + Math.random().toString(36).substr(2, 9);
            }
        },
        label: String,
        desc: String,
        modelValue: String
    },
    emits: ['update:modelValue', 'placechanged'],
    setup(props, { emit }){
        const addressField = ref(null)

        const autocomplete = ref(null)

        const mapLoader = new Loader({
            apiKey: 'AIzaSyB5EDgViPrC13ILPxMG5G7AfXlVbKZzByI',
            libraries: ['places']
        })

        const mapOptions = {
            types: ['address'],
            fields: ['address_components', 'adr_address', 'alt_id', 'formatted_address', 'geometry', 'icon', 'id', 'name', 'business_status', 'photo', 'place_id', 'scope', 'type', 'url', 'utc_offset_minutes', 'vicinity'],
            componentRestrictions: {
                country: 'US'
            }
        }

        const mapApi = ref(null)

        onMounted(() => {
            mapLoader.load().then((google) => {
                init(google)
            }).catch(error => {
                console.log('map api loader error:', error)
            })
        })

        function init(google){
            mapApi.value = google

            autocomplete.value = new google.maps.places.Autocomplete( addressField.value, mapOptions)

            autocomplete.value.addListener('place_changed', onPlaceChanged)
        }

        function onPlaceChanged(){
            let place = autocomplete.value.getPlace()
            let value = {
                address: '',
                city: '',
                state: '',
                zip: '',
                country: ''
            }

            if (place.address_components !== undefined) {
                for(const component of place.address_components){
                    const componentType = component.types[0]

                    switch (componentType) {
                        case "street_number": {
                            value.address = component.long_name
                            break;
                        }

                        case "route": {
                            value.address += ' ' + component.long_name
                            break;
                        }

                        case "locality": {
                            value.city = component.long_name
                            break;
                        }

                        case "administrative_area_level_1": {
                            value.state = component.short_name
                            break;
                        }

                        case "postal_code": {
                            value.zip = component.long_name
                            break;
                        }

                        case "country": {
                            value.country = component.short_name
                            break;
                        }
                    }
                }

                addressField.value.value = value.address
                emit('update:modelValue', value.address)
                emit('placechanged', value)
            }
        }

        function handleInput(e){
            emit('update:modelValue', e.target.value)
        }

        return {
            addressField,
            handleInput
        }
    },
    computed: {
        hasLabel(){
            return this.label != ''
        },
    }
})
</script>

<style>

</style>
